import React from "react";
import { Link } from "react-router-dom";

const FinalCTA = ({ title = "Potreban vam je kontejner?", text = "Pozovite nas ili pošaljite upit. Recite nam za koju namenu vam je potreban kontejner i pripremićemo odgovarajuću ponudu." }) => {
  return (
    <section className="section" data-testid="final-cta">
      <div className="container-rb">
        <div className="cta-banner">
          <div>
            <h2>{title}</h2>
            <p>{text}</p>
          </div>
          <div className="cta-banner__actions">
            <Link to="/kontakt" className="btn btn-white" data-testid="final-cta-contact">Kontaktirajte nas</Link>
            <Link to="/modeli-kontejnera" className="btn btn-outline" style={{ color: "#fff", borderColor: "rgba(255,255,255,0.6)" }} data-testid="final-cta-models">
              Pogledajte modele
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
